export const init = () => {
  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;
  const tc_vars = window.tc_vars || {};

  /* ENHANCED E-COMMERCE - IMPRESSION - PLV2 PRODUCT */

  if (!fwk.plv2.isLVP() && !fwk.plv2.isCrossSell() && !fwk.plv2.isBestSeller())
    return;

  // /**
  //  * CHECK FOR VISIBLE PLV2 ON SCROLL - EC-PRINT
  //  */
  // $(window).on(
  //   'scroll',
  //   cube.debounce(() => {
  //     // .plv2-element.slick-active:not(.viewed) : all pages plv2 - paginatted
  //     // .sportspage .plv2-element:not(.viewed) : sportspage plv2 - non paginated
  //     $(
  //       '.plv2-element.slick-active:not(.viewed), .plv2-element:not(.viewed)'
  //     ).each(function() {
  //       const $product = $(this);
  //       if (fwk.utils.isVisible($product)) fwk.plv2.sendImpression($product);
  //     });
  //   }, 150)
  // );
  // // After a slide, trigger a fake scroll event to trigger EC-print for new products
  // $('.product-list-v2').on('afterChange', () => {
  //   $(window).trigger('scroll');
  // });

  /**
   * CHECK FOR CLICK ON PLV2 - EC-CLICK
   */
  $('.plv2-element').on('click', '.plv2-el__image a', function handler() {
    // Parse MODEL
    const model = fwk.plv2.getSelectedModel($(this));

    // Update ST
    if (fwk.plv2.isBestSeller()) {
      let colorama = fwk.colorama.getDetail(model.id);
      if (colorama !== '') colorama += 'sportPage';
      fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)
      fwk.enhanced.set({
        id: model.id,
        position: model.position,
        list: model.list,
        variant: model.variant,
        category: model.category,
        label: model.name,
        brand: model.brand,
      });
      fwk.shoppingtool.set(
        'SportPagePushProduct',
        `${(tc_vars.env_sport
          ? tc_vars.env_sport
          : $('h1')
            .text()
            .trim()) + sep}position${sep}${model.position}`,
        colorama
      );
    } else fwk.shoppingtool.set('merchandising', `${model.type + sep + fwk.utils.getInfoPage() + sep}position${sep}${model.position}`, fwk.colorama.getDetail(model.id));

    // Send EC-CLICK
    fwk.enhanced.sendClick(model);
  });

  /**
   * CHECK FOR ACTION (ADD) ON PLV2 - EC-ADD2CART
   */
  // Listen for ADD2CART CLICK
  let originalEC = null;
  $('.plv2-element').on('click', '.cta.cart', function handler() {
    const model = fwk.plv2.getSelectedModel($(this));
    // Swap 'Actual' enhanced ecommerce informations
    originalEC = AnalyticsConstants.enhanced.actual;
    // And put it back a second later
    AnalyticsConstants.enhanced.actual = model;
    if (fwk.plv2.isBestSeller()) {
      let colorama = fwk.colorama.getDetail(model.id);
      if (colorama !== '') colorama += 'sportPage';
      fwk.shoppingtool.setTmp(
        'SportPagePushProduct',
        `${(tc_vars.env_sport
          ? tc_vars.env_sport
          : $('h1')
            .text()
            .trim()) + sep}position${sep}${model.position}`,
        model.name + sep + model.id + sep + model.sku,
        model.price,
        colorama
      );
    } else fwk.shoppingtool.setTmp('merchandising', `${model.type + sep + fwk.utils.getInfoPage() + sep}position${sep}${model.position}`, model.name + sep + model.id + sep + model.sku, model.price, fwk.colorama.getDetail(model.id));
  });

  // Listen for ADD2CART CONFIRMATION
  $('.plv2-element').on('confirm', '.cta.cart', function handler() {
    const model = fwk.plv2.getSelectedModel($(this));

    if (fwk.plv2.isBestSeller()) {
      let colorama = fwk.colorama.getDetail(model.id);
      if (colorama !== '') colorama += 'sportPage';
      fwk.shoppingtool.setTmp(
        'SportPagePushProduct',
        `${(tc_vars.env_sport
          ? tc_vars.env_sport
          : $('h1')
            .text()
            .trim()) + sep}position${sep}${model.position}`,
        model.name + sep + model.id + sep + model.sku,
        model.price,
        colorama
      );
    } else fwk.shoppingtool.setTmp('merchandising', `${model.type + sep + fwk.utils.getInfoPage() + sep}position${sep}${model.position}`, model.name + sep + model.id + sep + model.sku, model.price, fwk.colorama.getDetail(model.id));

    fwk.enhanced.sendAddToCart(model);
    // Unswap 'Tmp' enhanced ecommerce informations with original
    setTimeout(() => {
      AnalyticsConstants.enhanced.actual = originalEC;
    }, 500);
    // ShoppingTool AddToCart is auto-send in addtocart.js
  });
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-1-impression-plv2.js